<div class="container mt-3">
  <h4>Filtrar pedidos de piensos</h4>
  <div class="row mb-3">
    <div class="col-md-3 col-6 mb-2">
      <label for="priFech">Desde:</label>
      <input
        id="priFech"
        type="date"
        class="form-control"
        [(ngModel)]="primerafecha"
      />
    </div>
    <div class="col-md-3 col-6 mb-2">
      <label for="ultFech">Hasta:</label>
      <input
        id="ultFech"
        type="date"
        class="form-control"
        [(ngModel)]="ultimafecha"
      />
    </div>
    <div class="col-md-2 col-12 d-flex align-items-end mb-2">
      <button class="btn btn-primary w-100" (click)="cargarPiensos()">
        Buscar
      </button>
    </div>
    <div class="col-md-4 col-12 d-flex align-items-end mb-2">
      <button
        class="btn btn-success w-100"
        (click)="exportarAExcel()"
        [disabled]="tablaPivotada.length === 0"
      >
        <fa-icon [icon]="['fas', 'file-excel']"></fa-icon> Exportar a Excel
      </button>
    </div>
  </div>
</div>

<!-- Tabla desktop -->
<div class="container-fluid mt-3 d-none d-md-block">
  <div *ngIf="piensos.length === 0; else tablaPiensos"></div>
  <ng-template #tablaPiensos>
    <h4>Pedidos de piensos</h4>
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th rowspan="2">FECHA</th>
          <th rowspan="2">NOMBRE</th>
          <th rowspan="2">FINCA</th>
          <th rowspan="2">FORMATO</th>
          <ng-container *ngFor="let marca of marcasTipos">
            <th [attr.colspan]="marca.tipos.length" class="text-center">
              {{ marca.ttdesmar }}
            </th>
          </ng-container>
        </tr>
        <tr>
          <ng-container *ngFor="let marca of marcasTipos">
            <th *ngFor="let tipo of marca.tipos" class="text-center">
              {{ tipo.ttdestip }}
            </th>
          </ng-container>
        </tr>
      </thead>
      <!--
      <thead>
        <tr>
          <th rowspan="2">FECHA</th>
          <th rowspan="2">NOMBRE</th>
          <th rowspan="2">FINCA</th>
          <th rowspan="2">FORMATO</th>
          <th rowspan="2">PEDIDO</th>
          <th rowspan="2">SERVIDO</th>
          <ng-container *ngFor="let marca of marcasTipos">
            <th
              [attr.colspan]="marca.tipos.length"
              class="text-center bg-light"
            >
              {{ marca.ttdesmar }}
            </th>
          </ng-container>
        </tr>
        <tr>
          <ng-container *ngFor="let marca of marcasTipos">
            <th *ngFor="let tipo of marca.tipos" class="text-center">
              {{ tipo.ttdestip }}
            </th>
          </ng-container>
        </tr>
      </thead>
      -->

      <tbody>
        <tr *ngFor="let fila of tablaPivotada">
          <td>{{ fila.ttFecha }}</td>
          <td>{{ fila.ttNombr }}</td>
          <td>{{ fila.ttExplo }}</td>
          <td>{{ fila.ttForma === 0 ? "Envasado" : "Granel" }}</td>

          <ng-container *ngFor="let marca of marcasTipos">
            <td *ngFor="let tipo of marca.tipos" class="text-center">
              {{ obtenerCantidad(fila, marca, tipo) }}
            </td>
          </ng-container>
        </tr>
      </tbody>

      <!-- 
      <tbody>
        <tr *ngFor="let fila of tablaPivotada">
          <td>{{ fila.ttFecha }}</td>
          <td>{{ fila.ttNombr }}</td>
          <td>{{ fila.ttExplo }}</td>
          <td>{{ fila.ttForma === 0 ? "Envasado" : "Granel" }}</td>

          <td class="text-center">
            <input
              type="checkbox"
              [(ngModel)]="fila.ttPedido"
              [checked]="fila.ttPedido === 1"
              (change)="actualizarCampo(fila, 'ttPedido')"
            />
          </td>
          <td class="text-center">
            <input
              type="checkbox"
              [(ngModel)]="fila.ttServido"
              [checked]="fila.ttServido === 1"
              (change)="actualizarCampo(fila, 'ttServido')"
            />
          </td>

          <ng-container *ngFor="let marca of marcasTipos">
            <td *ngFor="let tipo of marca.tipos" class="text-center">
              {{ obtenerCantidad(fila, marca, tipo) }}
            </td>
          </ng-container>
        </tr>
      </tbody>
      -->
    </table>
  </ng-template>
</div>

<!-- Cards en móvil -->
<div class="container mt-3 d-md-none" *ngIf="tablaPivotada.length > 0">
  <h4>Pedidos de piensos</h4>
  <div class="row">
    <div class="col-12 mb-3" *ngFor="let fila of tablaPivotada">
      <div class="card pedido-card shadow-sm">
        <div class="card-body">
          <p><strong>Fecha:</strong> {{ fila.ttFecha }}</p>
          <p><strong>Nombre:</strong> {{ fila.ttNombr }}</p>
          <p><strong>Finca:</strong> {{ fila.ttExplo }}</p>
          <p>
            <strong>Formato:</strong>
            {{ fila.ttForma === 0 ? "Envasado" : "Granel" }}
          </p>

          <div *ngFor="let marca of marcasTipos" class="mb-2">
            <p>
              <strong>{{ marca.ttdesmar }}</strong>
            </p>
            <ul class="list-unstyled ms-3">
              <li *ngFor="let tipo of marca.tipos">
                {{ tipo.ttdestip }}:
                <span class="text-primary">
                  {{ obtenerCantidad(fila, marca, tipo) }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container mt-3 d-md-none" *ngIf="tablaPivotada.length === 0">
  <div class="alert alert-info">No hay pedidos en el rango seleccionado</div>
</div>
